import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from './store';
import Routes from './routes';
import App from 'shared/components/App';
import 'shared/styles/main-theme.css';

const rootElement = document.getElementById('root');

render(
  <Provider store={store}>
    <App>
      <Routes />
    </App>
  </Provider>,
  rootElement
);
